import { colors } from './colors';
import { Theme } from './structure';
import { text } from './text';

export const theme: Theme = {
  colors,
  text,
};
